import { useTranslation } from 'react-i18next';
import { useSearchParams, ScrollRestoration, Link} from "react-router-dom";
import { VTCartFinal } from 'vt-components'

import SEO from "components/SEO/SEO";

//Images
import img1 from "../../assets/img/content/final/final1.webp";
import img2 from "../../assets/img/content/final/final2.webp";
import img3 from "../../assets/img/content/final/final3.webp";

//CSS
import styles from "./finalBooking.module.less"
import React from "react";
import useGetZone from "../../hooks/useGetZone";

export default function FinalBooking() {
  const [t,i18n] = useTranslation("home","global");
  const [searchParams] = useSearchParams();
  const methodPayment = searchParams.get('method');
  const transactionID = searchParams.get('transactionID');
  const error = searchParams.get('error');
  const zone  = useGetZone();
  const config={
    locale:i18n.language,
    debug:process.env.REACT_APP_DEBUG
  }

  return(
    <>
      <SEO title={t("Finalizacion de compra")} description={t("Pantalla con el resultado de la finalizacion de su excursion.")} name='Viajes Teide' type='excursion' />

      <div className={styles.finalbooking}>

        <div className={styles.img1}>
          <img src={img1}/>
        </div>

        <div className={styles.info}>
          <VTCartFinal config={config} methodPayment={methodPayment} transactionID={transactionID} remoteError={error} />
        </div>

        <div className={styles.img2}>
          <img src={img2}/>
        </div>

        <div className={styles.img3}>
          <img src={img3}/>
        </div>

        <div className={styles.footer}>
          <p>{t('¿Tienes ganas de más?').toUpperCase()}</p>
          <p>{t('Te Puede interesar estas otras excursiones').toUpperCase()}</p>
        </div>
        <div className={styles.moreexcursions}>
          <Link to={'/' + i18n.language + '/search/' + zone}>{t('Ver mas excursiones').toUpperCase()}</Link>
        </div>

      </div>
      <ScrollRestoration />
    </>
  )
}